import React from 'react';
import * as UIcons from '@iconscout/react-unicons';
import LinkItem from 'components/Link';
import { withTranslation } from 'react-i18next';
import { FiPhoneCall } from 'react-icons/fi';
import { withRouter } from 'hooks/withRouter';

export default withTranslation()(withRouter(function Sidenav({ t, router: { params: { name } } }) {
  const navList = [
    {
      url: '/settings/business-info',
      icon: UIcons.UilBriefcase,
      text: t('settings.nav.business')
    },
    {
      url: '/settings/contact-person',
      icon: FiPhoneCall,
      text: t('settings.nav.contact')
    },
    {
      url: '/settings/settlement-bank',
      icon: UIcons.UilUniversity,
      text: t('settings.nav.bank')
    },
    {
      url: '/settings/user-management',
      icon: UIcons.UilUsersAlt,
      text: t('settings.nav.user')
    },
    {
      url: '/settings/payment-mode',
      icon: UIcons.UilUsersAlt,
      text: t('settings.nav.payment_method')
    },
    {
      url: '/settings/role-management',
      icon: UIcons.UilPhoneVolume,
      text: t('settings.nav.role')
    },
    {
      url: '/settings/pos-management',
      icon: UIcons.UilPhoneVolume,
      text: t('settings.nav.pos')
    },
    {
      url: '/settings/permission-management',
      icon: UIcons.UilPhoneVolume,
      text: t('settings.nav.permission')
    },
    {
      url: '/settings/cashback',
      icon: UIcons.UilGift,
      text: t('settings.cashback.cashback')
    },
    {
      url: '/settings/branches',
      icon: UIcons.UilStore,
      text: t('settings.nav.branches')
    },
    // {
    //   url: '/settings/categories',
    //   icon: UIcons.UilLayerGroup,
    //   text: t('settings.nav.categories')
    // },
    {
      url: '/settings/schedules',
      icon: UIcons.UilSchedule,
      text: t('settings.nav.schedules')
    },
    {
      url: '/settings/account-settings',
      icon: UIcons.UilSetting,
      text: t('settings.nav.settings')
    },
  ]

  return (
    <ul className="overflow-x-hidden">
      {
        navList.map(({ url, icon: Icon, text }) => {
          return (
            <li className="inline-block lg:block" key={url}>
              <LinkItem
                url={url}
                classList={`p-4 flex ${url.indexOf(name) > 0 ? 'text-primary font-medium' : 'text-secondary'}`}
                tag={
                  () => <>
                    <Icon className={`mr-2 ${url.indexOf(name) > 0 ? 'bg-primary text-white rounded-md p-1' : ''}`} size={24} />  {text}
                  </>
                }
              />
            </li>
          )
        })
      }
    </ul>
  )
}))


